import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';

import InfluencerSettingsDocumentUpload from './influencer-settings-document-upload/InfluencerSettingsDocumentUpload';

import { __t, applyTranslations } from 'utils/language';

import './bank-details-settings.scss';

applyTranslations(require('./bank-details-settings.i18n.json'));

import { OrganizationSettingsForm } from 'types';

type StateProps = {
  isDocumentProofSectionEnabled: boolean
}

type OwnProps = {
  children?: React.ReactNode,
  values: OrganizationSettingsForm,
  centerAligned?: boolean,
  isBankDetailsMissing?: boolean
}

type Props = StateProps & OwnProps;

const MSG_KEY = 'bank_details_settings';

const BankDetailsSettings = ({
  children,
  values,
  centerAligned,
  isBankDetailsMissing,
  isDocumentProofSectionEnabled
}: Props) => {
  const { bankDetails, proofDocuments } = values;

  const document = proofDocuments?.bankDetailsProof || null;

  const rowClass = classnames('bank-details-settings__row', {
    'bank-details-settings__row--center-aligned': centerAligned
  });

  if (isBankDetailsMissing) {
    return (
      <div className="bank-details-settings__missing-details-container">
        <div className="bank-details-settings__missing-error">
          {__t(`${MSG_KEY}.bank_details_missing_copy`)}
        </div>
        <div className="bank-details-settings__missing-note">
          {__t(`${MSG_KEY}.bank_details_missing_note`)}
        </div>
      </div>
    );
  }

  return (
    <div className="bank-details-settings">
      <div className={rowClass}>
        <div className="bank-details-settings__label">
          {__t(`${MSG_KEY}.account_name`)}
        </div>
        <div className="bank-details-settings__value">
          {bankDetails?.accountHolder}
        </div>
      </div>
      <div className={rowClass}>
        <div className="bank-details-settings__label">
          {__t(`${MSG_KEY}.account_number`)}
        </div>
        <div className="bank-details-settings__value">
          {bankDetails?.accountNumber}
        </div>
      </div>
      <div className={rowClass}>
        <div className="bank-details-settings__label">
          {__t(`${MSG_KEY}.swift`)}
        </div>
        <div className="bank-details-settings__value">
          {bankDetails?.swift}
        </div>
      </div>
      {
        isDocumentProofSectionEnabled && (
          <div className={rowClass}>
            <div className="bank-details-settings__label not-mandatory">
              {__t(`${MSG_KEY}.tax_registration_document.title`)}
            </div>
            <div className="bank-details-settings__value">
              <InfluencerSettingsDocumentUpload
                title={__t(`${MSG_KEY}.tax_registration_document.title`)}
                info={__t(`${MSG_KEY}.tax_registration_document.info`)}
                uploadButtonLabel={__t(`${MSG_KEY}.tax_registration_document.submit_btn`)}
                document={document}
                canEdit={false}
                onPreUpload={() => null}
                onDelete={() => null}
              />
            </div>
          </div>
        )
      }
      {children}
    </div>
  );
};

const mapStateToProps = ({ runtimeConfig }): StateProps => ({
  isDocumentProofSectionEnabled: runtimeConfig?.config?.settingsDocumentProofEnabled
});

export default connect(mapStateToProps)(BankDetailsSettings);
